function getSiteMessage() {
  var cached = sessionStorage.siteMessage;
  if (cached) {
    $(".overall-wrapper").prepend(cached);
    return;
  }
  $.ajax({
    type: "GET",
    dataType: "html",
    timeout: 10000,
    cache: true,
    url: "/",
    success: function (e) {
      var doc = shoptet.common.createDocumentFromString(e);
      var siteMsg = $(doc).find(".site-msg").prop("outerHTML");

      if (siteMsg) {
        sessionStorage.siteMessage = siteMsg;
        $(".overall-wrapper").prepend(siteMsg);
      }
    },
  });
}

function getCategories() {
  function normalizeCategoriesHtml(html) {
    var $categories = $(html);

    $categories.find("img").each(function () {
      var $img = $(this);
      var src = $img.attr("src") || "";
      var dataSrc = $img.attr("data-src") || "";

      if ((!src || src.indexOf("data:image") === 0) && dataSrc) {
        $img.attr("src", dataSrc);
      }
    });

    return $categories.prop("outerHTML");
  }

  if (sessionStorage.loadedCategories) {
    $(".cart-empty").append(normalizeCategoriesHtml(sessionStorage.loadedCategories));
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: "/",
      success: function (e) {
        var doc = shoptet.common.createDocumentFromString(e);
        var categoriesHtml = $(doc).find(".benefitBanner.position--benefitHomepage").prop("outerHTML");

        if (categoriesHtml) {
          sessionStorage.loadedCategories = categoriesHtml;
          $(".cart-empty").append(normalizeCategoriesHtml(categoriesHtml));
        }
      },
    });
  }
}

function getFavouriteProductsList() {
  if (sessionStorage.favouriteProductsList) {
    $(".cart-empty").append(sessionStorage.favouriteProductsList);
    slickFavuriteProducts();
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: "/",
      success: function (e) {
        var doc = shoptet.common.createDocumentFromString(e);
        var titleHtml = $(doc).find(".homepage-group-title.homepage-products-heading-3.h4").prop("outerHTML");
        var favouriteProductsList = $(doc).find("#products-3").prop("outerHTML");

        if (titleHtml || favouriteProductsList) {
          var wrappedHtml = `<div class="favouriteWrap ">${titleHtml || ""}${favouriteProductsList || ""}</div>`;
          $(".cart-empty").append(wrappedHtml);
          sessionStorage.favouriteProductsList = wrappedHtml;
          slickFavuriteProducts();
        }
      },
    });
  }
}

function slickFavuriteProducts() {
  $(".homepage-products-heading-3").text("Nejoblíbenější švihadla");
  $(".homepage-products-heading-3").append('<a href="/obchod/" class="btn-simple">Všechny produkty</a>');
  var $block = $(".favouriteWrap .products");
  if ($block.length) {
    if ($block.hasClass("slick-initialized")) {
      $block.slick("unslick");
    }

    $block.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3.5,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 1.5,
          },
        },
      ],
    });
  }
}

function getBannersLine() {
  if (sessionStorage.bannersLine) {
    $(".recapitulation-wrapper:has(.order-complete-links)").after(sessionStorage.bannersLine);
    $(".banners-line").prepend("<h2>Kam dál?</h2>");
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: "/",
      success: function (e) {
        var doc = shoptet.common.createDocumentFromString(e);
        var bannersLine = $(doc).find(".banners-line").prop("outerHTML");
        if (bannersLine) {
          $(".recapitulation-wrapper:has(.order-complete-links)").after(`${bannersLine}`);
          $(".banners-line").prepend("<h2>Kam dál?</h2>");
          sessionStorage.bannersLine = bannersLine;
        }
      },
    });
  }
}

function getHpBlog(onAfterInsert) {
  if (sessionStorage.hpBlog) {
    $(".recapitulation-wrapper:has(.order-complete-links)").after(sessionStorage.hpBlog);
    if (typeof onAfterInsert === "function") {
      onAfterInsert();
    }
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: "/",
      success: function (e) {
        var doc = shoptet.common.createDocumentFromString(e);
        var hpBlogHtml = $(doc).find(".hp-blog").prop("outerHTML");
        if (hpBlogHtml) {
          $(".recapitulation-wrapper:has(.order-complete-links)").after(`${hpBlogHtml}`);
          sessionStorage.hpBlog = hpBlogHtml;
          if (typeof onAfterInsert === "function") {
            onAfterInsert();
          }
        }
      },
    });
  }
}

function getUsps(domPlace) {
  if (sessionStorage.usps) {
    $(domPlace).append(sessionStorage.usps);
  } else {
    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: "/",
      success: function (e) {
        var doc = shoptet.common.createDocumentFromString(e);
        var uspsHtml = $(doc).find(".body-banners").prop("outerHTML");
        if (uspsHtml) {
          $(domPlace).append(`${uspsHtml}`);
          sessionStorage.usps = uspsHtml;
        }
      },
    });
  }
}
